import { preconUserId } from 'environment'

import { useActionless, useAppSelector } from 'app-redux/hooks'

import PreconSelector from 'components/deckPage/misc/EmptyDeckLanding/PreconSelector'
import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'

import { SET_ACTIVE_STATE } from 'app-redux/active/actions/types'
import { FORMAT } from 'types/deck'

export const FORMATS_WITH_PRECONSTRUCTED = [FORMAT.EDH]

const ImportFromPrecon = () => {
  const format = useAppSelector(state => state.deck.format)
  const preconsOverlay = useAppSelector(state => state.active.preconsOverlay)

  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  if (preconUserId === null) return null

  return (
    <GlobalOverlayStack open={preconsOverlay} onClose={() => setActiveState({ preconsOverlay: false })}>
      <PreconSelector format={format} onClose={() => setActiveState({ preconsOverlay: false })} />
    </GlobalOverlayStack>
  )
}

export default ImportFromPrecon
